import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import QuotationDocument from './components/QuotationDocument';
import DocumentActions from './components/DocumentActions';
import { preliminaryQuoteData, finalOfferData } from '@/mocks/quotationDocument';
import type { QuotationDocType } from './types';

const tabs: { id: QuotationDocType; label: string }[] = [
  { id: 'preliminary', label: 'Preliminary Quotation' },
  { id: 'final', label: 'Final Offer' },
];

export default function QuotationDesignPage() {
  const navigate = useNavigate();
  const [docType, setDocType] = useState<QuotationDocType>('preliminary');

  const data = docType === 'preliminary' ? preliminaryQuoteData : finalOfferData;

  const actions =
    docType === 'preliminary'
      ? [
          { label: '이전 단계', icon: 'ri-arrow-left-line' },
          { label: '실제로 주문하기', icon: 'ri-shopping-bag-3-line', primary: true },
          { label: '1차 견적서 PDF 보기', icon: 'ri-file-pdf-line', primary: true },
        ]
      : [
          { label: '사전 견적 보기', icon: 'ri-arrow-left-line' },
          { label: '최종 견적서 PDF 보기', icon: 'ri-file-pdf-line', primary: true },
        ];

  return (
    <div className="min-h-screen bg-cream-50 flex flex-col">
      {/* Top bar */}
      <div className="sticky top-0 z-30 bg-white border-b border-ink-100">
        <div className="w-full px-4 md:px-6 py-3 flex items-center justify-between gap-4">
          <div className="flex items-center gap-2.5 min-w-0">
            <div className="w-7 h-7 rounded-lg bg-ink-700 flex items-center justify-center shrink-0">
              <i className="ri-file-text-line text-white text-sm" />
            </div>
            <div className="min-w-0">
              <h1 className="text-base font-extrabold text-ink-700 truncate">
                견적서 디자인 미리보기
              </h1>
            </div>
          </div>

          {/* Segmented control */}
          <div className="flex items-center gap-1 bg-cream-100 rounded-full px-1 py-1 shrink-0">
            {tabs.map((t) => (
              <button
                key={t.id}
                onClick={() => setDocType(t.id)}
                className={`px-4 py-1.5 text-xs md:text-sm font-bold rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                  docType === t.id
                    ? 'bg-ink-700 text-white'
                    : 'text-ink-500 hover:text-ink-700'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>

          <button
            onClick={() => navigate(-1)}
            className="px-3 py-1.5 text-xs font-medium text-ink-500 border border-ink-200 rounded-lg hover:bg-cream-50 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1 shrink-0"
          >
            <i className="ri-arrow-left-line" />
            뒤로
          </button>
        </div>
      </div>

      {/* Document preview */}
      <main className="flex-1 w-full px-4 md:px-6 py-8 md:py-12">
        <QuotationDocument data={data} />

        {/* Action bar (below document) */}
        <div className="mx-auto w-full max-w-[840px] mt-8">
          <DocumentActions actions={actions} />
          {docType === 'preliminary' && (
            <p className="mt-4 text-center text-xs text-ink-400 leading-relaxed">
              본사 담당자가 배송, 결제 및 거래조건을 검토한 후 최종 견적서를 발행합니다.
            </p>
          )}
        </div>
      </main>
    </div>
  );
}